/**
 * atlas-cvp-enhancements.js
 * Small, additive companion script for the flavour-grid redesign (draft theme).
 * Does NOT modify atlas-product-custom-variant-picker.js — it layers one thing
 * on top of the existing swatch-table rows:
 *   Clicking anywhere on a row (not just the hidden .cvp-action button)
 *   selects that flavour, by delegating to the row's own .cvp-action button
 *   so all of the original script's selection logic still runs unchanged.
 */
(function () {
    function initRoot(root) {
        if (root.__cvpEnhanceBound) return;
        root.__cvpEnhanceBound = true;

        root.addEventListener('click', function (e) {
            // Let the original script's own listener handle real clicks on the action button.
            if (e.target.closest('.cvp-action')) return;

            var rowLabel = e.target.closest('label.atlas-cvp__table-row, label.atlas-cvp__table-main');
            if (!rowLabel) return;

            // Don't hijack clicks meant for other interactive controls inside a row
            // (quantity steppers, free-text messages on "swatch-table-text" steps).
            var excluded = e.target.closest('.js-cvp-inc, .js-cvp-dec, .atlas-cvp__textarea, .atlas-cvp__text-input');
            if (excluded) return;

            var row = rowLabel.closest('.atlas-cvp__table-row') || rowLabel;
            var rowBtn = row && row.querySelector('.cvp-action');
            if (rowBtn) {
                e.preventDefault();
                e.stopPropagation();
                rowBtn.click();
            }
        });
    }

    function scan() {
        var roots = document.querySelectorAll('.atlas-custom-variant-picker');
        for (var i = 0; i < roots.length; i++) initRoot(roots[i]);
    }

    if (document.readyState !== 'loading') scan();
    else document.addEventListener('DOMContentLoaded', scan);

    // The picker can mount asynchronously; keep watching briefly in case scan()
    // ran before the container existed.
    var bodyMo = new MutationObserver(scan);
    bodyMo.observe(document.documentElement, { childList: true, subtree: true });
})();
